import RouteTemplate from 'ember-route-template';
import { PageLoading } from 'embroil/components/loading';

export default RouteTemplate(
  <template>
  <PageLoading @message="Loading latest news..." @subtitle="Getting the freshest gaming news and updates" />
</template>
);
